import {useState} from 'react';

interface JobTitleStepProps {
  onSubmit: (jobTitle: string) => void;
}

export const JobTitleStep = ({onSubmit}: JobTitleStepProps) => {
  const [jobTitle, setJobTitle] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    if (!jobTitle.trim()) {
      setError('Job title is required');
      return;
    }
    onSubmit(jobTitle);
  };

  return (
    <div className="step-content step-2">
      <p className="step-subtitle">Let's set up your profile!</p>
      <h2 className="step-title">What's your job title?</h2>
      <div className="form-group">
        <input
          type="text"
          placeholder="Enter your job title"
          className="form-input"
          value={jobTitle}
          onChange={(e) => {
            setJobTitle(e.target.value);
            setError(null);
          }}
        />
        {error && <span className="error-message">{error}</span>}
      </div>
      <button type="button" className="submit-button" onClick={handleSubmit} disabled={!jobTitle.trim()}>
        Continue
      </button>
    </div>
  );
};
